<script setup lang="ts">
import {computed, type PropType, ref} from 'vue';
import {ElInput, ElInputNumber, ElOption, ElSelect} from 'element-plus';
import {CabFteTarget, CabOrganization, FteTargetMetricEnum, FteTargetMetricEnum_name, uuidOf} from 'common';
import {FTE_TARGET_CHANGE_EMIT, FTE_TARGET_REMOVE_EMIT} from '@/base/cabConstants';
import DeleteButton from '@/views/icons/DeleteIcon.vue';

const emits = defineEmits([FTE_TARGET_REMOVE_EMIT, FTE_TARGET_CHANGE_EMIT]);
const props = defineProps({
    target: {
        type    : Object as PropType<CabFteTarget>,
        required: true,
    },
    allOrganizations: {
        type    : Array as PropType<CabOrganization[]>,
        required: true,
    },
});

const target         = ref<CabFteTarget>(props.target);
const organizationId = computed<string | undefined>({
    get: () => target.value.organization[0] ? uuidOf(target.value.organization[0]) : undefined,
    set: (id: string | undefined) => {
        const org: CabOrganization | undefined = props.allOrganizations.find(o => uuidOf(o) === id);
        target.value.organization              = org ? [org] : [];
        onChange();
    },
});

function onChange() {
    emits(FTE_TARGET_CHANGE_EMIT, target.value);
}

function onDelete() {
    emits(FTE_TARGET_REMOVE_EMIT, target.value);
}
</script>

<template>
    <div class="flex flex-row items-center gap-2 w-full font-medium m-0.5 p-1 bg-yellow-100 text-gray-900">
        <el-select v-model="organizationId" placeholder="organisatie" class="w-56" filterable>
            <el-option v-for="o in allOrganizations" :key="uuidOf(o)" :value="uuidOf(o)" :label="o.name"/>
        </el-select>
        <el-input v-model="target.kwartaal" placeholder="YYYY-Qn" class="w-24" @change="onChange"/>
        <el-select v-model="target.metric" placeholder="metric" class="w-56" @change="onChange">
            <el-option v-for="m in Object.values(FteTargetMetricEnum)" :key="m" :value="m" :label="FteTargetMetricEnum_name(m)"/>
        </el-select>
        <el-input-number v-model="target.fte" :controls="false" :precision="2" class="w-28" title="FTE" @change="onChange"/>
        <div class="flex-1"/>
        <DeleteButton @click="onDelete()"/>
    </div>
</template>
